var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"sidebar-item-child",class:{'-active': _vm.isActive}},[_c('a',_vm._b({staticClass:"link",attrs:{"href":_vm.href},on:{"click":_vm.navigate}},'a',_vm.$attrs,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }